import $ from 'jquery'

export default {
    name: 'manage-admission',
    components: {},
    props: {
        admission_to_fill: Object,
        type_admission_to_delete: Object,
        adm_modal_title: String,
        type_admission: String,
        is_edit: Number
    },
    data() {
        return {
            save_loading: false,
            chambre_is_empty: false,
            observation_is_empty: false,
            must_create_room: false,
            must_create_observation: false,

            is_exist: false,
            is_error: false,

            del_loading: false,
            is_confirm: false,

            msg_error: ""
        }
    },

    watch: {
        admission_to_fill() {
            this.getListeChambre()
            this.getListeObservation()
            this.clearError()
            this.$refs.adm_form.reset()
        },

        type_admission_to_delete() {
            this.is_confirm = false
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        },

        liste_chambres() {
            return this.$store.getters["liste_chambres"];
        },

        liste_observations() {
            return this.$store.getters["liste_observations"];
        },
    },

    mounted() {
        // Liste facturation acte
        this.getListeFacturatonActe()

        // this.getListeChambre()
        // this.getListeObservation()
    },

    methods: {
        getListeFacturatonActe() {
            this.$store.dispatch("getListeTypeMixData", 'facturation_acte')
        },

        async getListeChambre() {
            this.$store.dispatch("getListeTypeAdmission", 'chambre').then(() => {
                if (this.liste_chambres.length == 0) {
                    this.chambre_is_empty = true
                } else {
                    this.chambre_is_empty = false
                }
            })
        },

        getListeObservation() {
            this.$store.dispatch("getListeTypeAdmission", 'observation').then(() => {
                if (this.liste_observations.length == 0) {
                    this.observation_is_empty = true
                } else {
                    this.observation_is_empty = false
                }
            })
        },

        /**
         * Efface le prix défini pour le prix d'une admission au changement
         */
        handleFacturationAdmission(type) {
            if (type == 'admission') {
                this.admission_to_fill.prix = ""
                this.admission_to_fill.prix_journalier = ""
                this.admission_to_fill.facturation_acte = null
            } else if (type == 'observation') {
                this.admission_to_fill.facturation_acte = null
                this.admission_to_fill.prix_journalier = ""
            } else {
                this.admission_to_fill.prix_journalier = ""
            }  
        },

        handleActionTypeChambre() {
            this.admission_to_fill.lits = [
                {
                    libelle: ''
                }
            ]
        },

        addLit() {
            this.msg_error = ""
            let one_is_empty = false
            this.admission_to_fill.lits.forEach(lit => {
                if (lit.libelle === '' || lit === '') {
                    one_is_empty = true
                }
            });
            if (one_is_empty) {
                this.msg_error = "Vous devez renseigner le nom du lit avant d'ajouter un autre lit."
                return;
            }

            this.admission_to_fill.lits.push({
                libelle: ''
            })
        },

        async submit() {
            let isValid = null
            if (this.type_admission == 'admission') {
                isValid = await this.$refs.adm_form.validate();
            } else {
                isValid = await this.$refs.autre_adm_form.validate();
            }

            if (!isValid) {
                return;
            }

            if (this.type_admission == 'admission') {
                // Check if at least one "Chambre" is created
                if (this.admission_to_fill.is_with_room == 1 && this.chambre_is_empty) {
                    this.must_create_room = true
                    return;
                }

                // Check if at least one "Observation" is created
                if (this.admission_to_fill.is_with_observation == 1 && this.observation_is_empty) {
                    this.must_create_observation = true
                    return;
                }
            }

            this.save_loading = true 
            this.$store.dispatch('storeAdmission', this.admission_to_fill).then((response) => {
                if (response.success) {
                    if (this.type_admission == 'admission') {
                        this.successToast("Admission ajoutée avec succès")

                        this.$refs.adm_form.reset()
                        this.$emit('emitAdmission')
                        this.$refs.modal_admission.click()
                    } else if (this.type_admission == 'chambre') {
                        this.successToast("Chambre ajoutée avec succès")

                        this.$refs.autre_adm_form.reset()
                        this.$emit('emitChambre')
                        this.$refs.modal_autre_admission.click()
                    } else if (this.type_admission == 'observation') {
                        this.successToast("Observation ajoutée avec succès")

                        this.$refs.autre_adm_form.reset()
                        this.$emit('emitObservation')
                        this.$refs.modal_autre_admission.click()
                    }
                    
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur est survenue. Veuillez réessayer plus tard."
            })

        },

        clearError() {
            this.must_create_room = false
            this.must_create_observation = false
            this.is_exist = false
            this.is_error = false
            this.msg_error = ""
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteAdmissionByType', this.type_admission_to_delete).then((response) => {
                if (response > 0) {
                    this.successToast("Suppression effectuée avec succès")

                    if (this.type_admission_to_delete.type_del == 'admission') {
                        this.$emit('emitAdmission')
                    } else if (this.type_admission_to_delete.type_del == 'chambre') {
                        this.$emit('emitChambre')
                    } else if (this.type_admission_to_delete.type_del == 'observation') {
                        this.$emit('emitObservation')
                    }

                    this.is_confirm = false
                    this.$refs.del_admission.click();
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
            })
        },
    }
}


